// Single source of truth for permission page names on the client. Mirrors
// server/utils/permissionPages.js - keep the two in sync. Used by the
// permission editor (so it never drifts from what the server accepts) and by
// any page component that gates itself with usePermissions().
export const PERMISSION_PAGES = [
  "PoS",
  "Invoices",
  "Customers",
  "Suppliers",
  "Supplier Dues",
  "Purchase",
  "Stock Adjustment",
  "Stock Summary",
  "Payments & Receipts",
  "Items",
  "Units",
  "Employee Master",
  "Shift Logs",
  "Staff",
  "Dashboard",
  "Settings",
  "Goods Returns",
];
